import { useEffect, useState } from "react";
import {
  subscribeTripComplianceEvents,
  subscribeTripOfflineInfringements,
  subscribeTripTrackingEvents,
  subscribeTripTrackingSamples,
} from "../services/firestoreTracking.service";

export function useTripTrackingActivity(tripId, enabled = true) {
  const [trackingEvents, setTrackingEvents] = useState([]);
  const [trackingSamples, setTrackingSamples] = useState([]);
  const [complianceEvents, setComplianceEvents] = useState([]);
  const [offlineInfringements, setOfflineInfringements] = useState([]);
  const [loading, setLoading] = useState(Boolean(tripId) && enabled);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!tripId || !enabled) {
      setTrackingEvents([]);
      setTrackingSamples([]);
      setComplianceEvents([]);
      setOfflineInfringements([]);
      setLoading(false);
      setError(null);
      return undefined;
    }

    let completedCount = 0;
    const markLoaded = () => {
      completedCount += 1;
      if (completedCount >= 4) {
        setLoading(false);
      }
    };

    setTrackingEvents([]);
    setTrackingSamples([]);
    setComplianceEvents([]);
    setOfflineInfringements([]);
    setLoading(true);
    setError(null);

    const unsubscribeTrackingEvents = subscribeTripTrackingEvents(
      { tripId, limitCount: 50 },
      (records) => {
        setTrackingEvents(records);
        markLoaded();
      },
      (nextError) => {
        setError(nextError);
        setLoading(false);
      }
    );

    const unsubscribeTrackingSamples = subscribeTripTrackingSamples(
      { tripId, limitCount: 1500 },
      (records) => {
        setTrackingSamples(records);
        markLoaded();
      },
      (nextError) => {
        setError(nextError);
        setLoading(false);
      }
    );

    const unsubscribeComplianceEvents = subscribeTripComplianceEvents(
      { tripId, limitCount: 50 },
      (records) => {
        setComplianceEvents(records);
        markLoaded();
      },
      (nextError) => {
        setError(nextError);
        setLoading(false);
      }
    );

    const unsubscribeOfflineInfringements = subscribeTripOfflineInfringements(
      { tripId, limitCount: 50 },
      (records) => {
        setOfflineInfringements(records);
        markLoaded();
      },
      (nextError) => {
        setError(nextError);
        setLoading(false);
      }
    );

    return () => {
      unsubscribeTrackingEvents?.();
      unsubscribeTrackingSamples?.();
      unsubscribeComplianceEvents?.();
      unsubscribeOfflineInfringements?.();
    };
  }, [tripId, enabled]);

  return {
    trackingEvents,
    trackingSamples,
    complianceEvents,
    offlineInfringements,
    loading,
    error,
  };
}
